export enum ReaderTypes {
	CSV = 0,
	XML = 1,
	JSON = 2,
}
